import { render, staticRenderFns } from "./pczx_index.vue?vue&type=template&id=714c9170&"
import script from "./pczx_index.vue?vue&type=script&lang=js&"
export * from "./pczx_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports